import React, { useState, useEffect } from "react"
import axios from "axios"
import Post from "./Post"

function BlogPostAll() {
  const [posts, setBlog] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      const response = await axios.get(gameonlineData.root_url + '/wp-json/allposts/v1/blogpost')
      setBlog(response.data);
    }
    fetchPosts();
  }, []);

//   console.log(posts)
  return (
    <>    
      <Post data={ posts } />
    </>
  )

}
export default BlogPostAll

